import React from 'react';
import styles from './MarketingShared.module.css';

/** Linhas de carregamento no formato das linhas reais. */
function MarketingListSkeleton({ rows = 4 }) {
  return (
    <ul className={styles.list} aria-busy="true" aria-label="Carregando">
      {Array.from({ length: rows }).map((_, index) => (
        <li key={index} className={styles.skeletonRow}>
          <span className={`${styles.shimmer} ${styles.skeletonAvatar}`} />
          <span className={styles.skeletonText}>
            <span className={`${styles.shimmer} ${styles.skeletonLine}`} style={{ width: `${60 - index * 8}%` }} />
            <span className={`${styles.shimmer} ${styles.skeletonLineSm}`} />
          </span>
        </li>
      ))}
    </ul>
  );
}

export default MarketingListSkeleton;
